import { useAuthStore } from '../stores/auth.store'
import { ShieldX, LogOut } from 'lucide-react'
import './AccessDenied.scss'

export function AccessDenied() {
  const { signOut, user } = useAuthStore()

  return (
    <div className="access-denied-page">
      <div className="access-denied-card">
        <div className="icon">
          <ShieldX size={48} />
        </div>
        <h1>Access Denied</h1>
        <p>
          Sorry, you don't have permission to access the QR Code Generator.
        </p>
        {user && (
          <p className="user-info">
            Signed in as: <strong>{user.email}</strong>
          </p>
        )}
        <button className="sign-out-btn" onClick={signOut}>
          <LogOut size={18} />
          Sign out
        </button>
      </div>
    </div>
  )
}
